// extracted by mini-css-extract-plugin
module.exports = {"content":"style-module--content--WB3SM","header":"style-module--header--3IX4a"};